/**
 * Leaflet - Shared Map Configuration
 * Expose Leaflet globally for use in templates
 */

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Expose Leaflet globally for backward compatibility with inline scripts
window.L = L;

export default L;
